import type { UIState, UIAction } from '../types';

export function uiReducer(state: UIState, action: UIAction): UIState {
  switch (action.type) {
    case 'SET_VIEW':
      return { ...state, view: action.view };
    case 'SET_VIEW_MODE':
      return { ...state, viewModes: { ...state.viewModes, [action.viewKey]: action.modeKey } };
    case 'ADD_ATTACHMENTS':
      return { ...state, attachments: [...state.attachments, ...action.attachments] };
    case 'SET_ATTACHMENT_ERRORS':
      return { ...state, attachmentErrors: action.errors };
    case 'CLEAR_ATTACHMENT_ERRORS':
      return { ...state, attachmentErrors: [] };
    case 'REMOVE_ATTACHMENT': {
      const att = state.attachments.find(a => a.id === action.id);
      if (att?.previewUrl) URL.revokeObjectURL(att.previewUrl);
      return { ...state, attachments: state.attachments.filter(a => a.id !== action.id) };
    }
    case 'CLEAR_ATTACHMENTS': {
      state.attachments.forEach(a => {
        if (a.previewUrl) URL.revokeObjectURL(a.previewUrl);
      });
      return { ...state, attachments: [] };
    }
    case 'SET_FULLSCREEN':
      return { ...state, isFullscreen: action.isFullscreen };
    case 'INCREMENT_UNREAD':
      return { ...state, unreadCount: state.unreadCount + 1 };
    case 'RESET_UNREAD':
      return { ...state, unreadCount: 0 };
    default:
      return state;
  }
}

export const initialUIState: UIState = {
  view: 'chat',
  viewModes: {},
  attachments: [],
  attachmentErrors: [],
  isFullscreen: false,
  unreadCount: 0,
};
